import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import TrafficInsurance from './pages/services/TrafficInsurance';
import Kasko from './pages/services/Kasko';
import HomeInsurance from './pages/services/HomeInsurance';
import DASK from './pages/services/DASK';
import ComplementaryHealth from './pages/services/ComplementaryHealth';
import PrivateHealth from './pages/services/PrivateHealth';
import Contact from './pages/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkımızda" element={<About />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/hizmetler/trafik-sigortasi" element={<TrafficInsurance />} />
            <Route path="/hizmetler/kasko" element={<Kasko />} />
            <Route path="/hizmetler/konut-sigortasi" element={<HomeInsurance />} />
            <Route path="/hizmetler/dask" element={<DASK />} />
            <Route path="/hizmetler/tamamlayici-saglik" element={<ComplementaryHealth />} />
            <Route path="/hizmetler/ozel-saglik" element={<PrivateHealth />} />
            <Route path="/iletisim" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
